<template>
  <BModal
    id="modal-status-download"
    hide-footer
    hide-header
    :centered="true"
    v-bind="$attrs"
    lazy
    body-class="p-0"
  >
    <div class="flex flex-col justify-center items-center text-center gap-6 px-[32px] py-[40px]">
      <!-- Image / Icon / Spinner -->
      <div class="flex justify-center items-center h-[100px]">
        <BSpinner
          v-if="status === 'loading' && !currentConfig.image"
          variant="primary"
          style="width: 4rem; height: 4rem;"
        />
        <img
          v-else-if="currentConfig.image"
          :src="currentConfig.image"
          alt="Modal Status Icon"
          width="100"
          class="object-contain"
        >
      </div>

      <!-- Title & Message -->
      <div class="flex flex-col gap-2">
        <h4
          v-if="currentConfig.title"
          class="font-bold text-[20px] text-black"
        >
          {{ currentConfig.title }}
        </h4>

        <p
          v-if="currentConfig.message"
          class="text-[#6B7280] text-[14px] leading-relaxed max-w-[320px]"
        >
          {{ currentConfig.message }}
        </p>
      </div>
    </div>
  </BModal>
</template>

<script>
import { BModal, BSpinner } from 'bootstrap-vue'

const STATUS_CONFIG = {
  loading: {
    image: '',
    title: 'Sedang Memproses File',
    message: 'Mohon tunggu sebentar, permintaan download sedang diproses.',
  },
  email: {
    image: 'https://storage.googleapis.com/komerce/core/icon-popup-success.png',
    title: 'Permintaan Download Diproses',
    message: 'File akan dikirimkan ke alamat email kamu. Mohon cek email secara berkala.',
  },
  device: {
    image: 'https://storage.googleapis.com/komerce/core/icon-popup-success.png',
    title: 'File Berhasil Didownload',
    message: 'File akan tersimpan di perangkat kamu.',
  },
  queue: {
    image: 'https://storage.googleapis.com/komerce/core/icon-popup-warning.png',
    title: 'File Sedang Disiapkan',
    message: 'Permintaan file sedang disiapkan. Kami akan mengirimkannya ke email kamu setelah selesai.',
  },
  error: {
    image: 'https://storage.googleapis.com/komerce/core/icon-popup-warning.png',
    title: 'Download Gagal Diproses',
    message: 'Koneksi internet tidak stabil. Periksa koneksi kamu, lalu coba lagi.',
  },
  empty: {
    image: 'https://storage.googleapis.com/komerce/core/icon-popup-warning.png',
    title: 'Data Tidak Ditemukan',
    message: 'Tidak ada data rincian saldo pada rentang tanggal yang dipilih.',
  },
}

export default {
  name: 'ModalStatusDownload',
  components: {
    BModal,
    BSpinner,
  },
  props: {
    status: {
      type: String,
      default: 'loading',
      validator: value => !value || ['loading', 'email', 'device', 'queue', 'error', 'empty'].includes(value),
    },
  },
  computed: {
    currentConfig() {
      const config = STATUS_CONFIG[this.status] || STATUS_CONFIG.email || {}
      return {
        image: config.image || '',
        title: config.title || '',
        message: config.message || '',
      }
    },
  },
}
</script>
